import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import classnames from 'clsx';
import { OrderItemPropType } from '../../prop-types/order-item';
import { ItemDisplay } from './components/item-display.component';
import { Quantity } from './components/item-quantity.component';
import { InventoryStockCountContainer } from './components/inventory-stock-count.container';
import { InventoryItemIcon } from './components/inventory-item-icon';
import style from './style.module.less';

export const SidebarLineItem = ({ orderItem = {}, fulfillmentPlanId, willInventoryShow = false, openProductDetailModal }) => {
  const {
    quantity = 0,
    name,
    sku,
    attributes,
    productThumbnailUrl,
    productId,
    bundleProductId,
    bundleProductSku,
    dangerousGoods,
  } = orderItem;
  const isClassifiedAsDangerousGoods = dangerousGoods?.length > 0;

  const onNameClicked = useCallback(() => openProductDetailModal(productId), [productId, openProductDetailModal]);
  const onBundleClick = useCallback(() => openProductDetailModal(bundleProductId), [bundleProductId, openProductDetailModal]);
  return (
    <>
      <div className={classnames(style.tile, style['item-display-wrapper'])}>
        <ItemDisplay
          attributes={attributes}
          bundleProductId={bundleProductId}
          bundleProductSku={bundleProductSku}
          className={style['item-display']}
          isClassifiedAsDangerousGoods={isClassifiedAsDangerousGoods}
          name={name}
          onBundleClick={onBundleClick}
          onNameClicked={onNameClicked}
          productId={productId}
          productThumbnailUrl={productThumbnailUrl}
          sku={sku}
        />
      </div>
      <div
        className={classnames(style.tile, style['quantity-column'], {
          [style['border-right']]: !willInventoryShow,
        })}
      >
        <div className={classnames(style['content-wrapper'])}>
          <Quantity quantity={quantity} />
          <InventoryItemIcon fulfillmentPlanId={fulfillmentPlanId} isInOrdersDrawer orderItem={orderItem} quantity={quantity} />
        </div>
      </div>
      <InventoryStockCountContainer
        className={style['border-right']}
        fulfillmentPlanId={fulfillmentPlanId}
        isInOrdersDrawer
        orderItem={orderItem}
        quantity={quantity}
      />
    </>
  );
};

SidebarLineItem.propTypes = {
  orderItem: OrderItemPropType.isRequired,
  fulfillmentPlanId: PropTypes.string.isRequired,
  willInventoryShow: PropTypes.bool,
  openProductDetailModal: PropTypes.func.isRequired,
};
